import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../ui-compoenents/table";
import { Link } from "react-router-dom";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import CommonConfirmationModal from "../../ui-compoenents/common-conformation-modal";
import AddNakshtraFormModal from "./component/add-nakshatra-form-modal";
import {
  getNakshatrAsync,
  updateNakshatrAsync,
} from "../../data/redux/features/nakshtra/slice";

const NakshtraList = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const dispach = useDispatch();
  const { fetchLoading, loading, nakshtraData } = useSelector(
    (state) => state.nakshtra
  );

  useEffect(() => {
    dispach(getNakshatrAsync());
  }, [dispach]);

  const columns = [
    {
      title: "Start Time",
      dataIndex: "start_time",
      key: "age",
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      key: "name",
    },

    {
      title: "name",
      dataIndex: "name",
      key: "address",
    },

    {
      title: "Active",
      dataIndex: "is_active",
      render: (_, record) => {
        return (
          <div>
            {record.is_active === true ? (
              <span className="badge badge-soft-success">True</span>
            ) : (
              <span className="badge badge-soft-danger">False</span>
            )}
          </div>
        );
      },
    },
    {
      title: "Action",
      render: (_, record) => {
        return (
          <div
            className={`${
              !record?.is_active
                ? "btn btn-sm btn-success"
                : "btn btn-sm btn-danger"
            }`}
            data-bs-toggle="modal"
            data-bs-target="#active-modal"
            onClick={() => setSelectedItem(record)}
            style={{ cursor: "pointer" }}
          >
            {!record?.is_active ? "Active" : "In Active"}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="p-4 bg-white rounded shadow-sm">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-3">Nakshtra List</h5>
          <Link
            to="#"
            className="btn btn-sm btn-primary fw-bold fs-14  "
            data-bs-toggle="modal"
            data-bs-target="#add_nakshtra_form_modal"
            onClick={() => setSelectedItem(null)}
          >
            <IoIosAddCircleOutline className="me-1" />
            Add
          </Link>
        </div>

        <CustomTable
          dataSource={nakshtraData}
          columns={columns}
          loading={fetchLoading}
        />
      </div>

      <AddNakshtraFormModal selectedItem={selectedItem} />

      <CommonConfirmationModal
        text={selectedItem?.is_active ? "In Active" : "Active"}
        buttonId="cancle-cancel"
        id="active-modal"
        loading={loading}
        icon={!selectedItem?.is_active ? <FaCheckCircle /> : <FaTimesCircle />}
        variant={selectedItem?.is_active ? "danger" : "success"}
        onConfirm={async () => {
          try {
            if (selectedItem) {
              const result = await dispach(
                updateNakshatrAsync({
                  updateNakshatrValues: {
                    id: selectedItem?.id,
                    is_active: !selectedItem?.is_active,
                  },
                })
              ).unwrap();
              if (result) {
                const cancelButton = document.getElementById("cancle-cancel");
                cancelButton.click();
                setSelectedItem(null);
                // setSelectedTeacher(null);
                dispach(getNakshatrAsync());
              }
            }
          } catch (error) {
            console.error(error);
          }
        }}
      />
    </>
  );
};

export default NakshtraList;
